import tests from "./tests";

const testListService = [
    {
        matcher: 'tests',
        reply: config => {
            return [200, tests];
        }
    },
]

export default testListService;